module.exports = __webpack_public_path__ + "img/order-processing.bf2c2d4d.gif";